import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="relative bg-gradient-to-br from-navy via-navy-mid to-[#0d2e1a] px-5 py-10 pb-12 sm:py-16 sm:pb-20 text-center overflow-hidden" data-id="element-136">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_50%_0%,rgba(26,107,74,0.25)_0%,transparent_70%)]" data-id="element-137" />

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5
    }} className="relative z-10 max-w-7xl mx-auto" data-id="element-138">
        <div className="inline-block bg-gold/15 border border-gold text-gold-light sm:text-xs font-semibold tracking-[0.12em] uppercase px-4 py-1.5 rounded-full mb-5 sm:mb-6 text-[8px]" data-id="element-139">
          🩺 Solucionesya.shop — Herramientas para veterinarios
        </div>

        <h1 className="font-display text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-black text-white leading-tight mb-4 sm:mb-6" data-id="element-140">
          La Consulta
          <br data-id="element-141" />
          <span className="text-gold-light" data-id="element-142">Perfecta</span>
        </h1>

        <div className="mb-2 sm:mb-3" data-id="element-143">
          <img src="https://cdn.magicpatterns.com/uploads/isn3j5d1hpo7aKVw84SC3y/mockup_fondo_transparente.png" alt="La Consulta Perfecta - Kit completo de guías para veterinarios" loading="eager" fetchPriority="high" decoding="async" width={700} height={700} className="max-w-full h-auto mx-auto max-h-[182px] sm:max-h-[350px] object-contain drop-shadow-2xl" data-id="element-144" />
        </div>

        <p className="text-[10px] sm:text-xs text-white/45 max-w-xl mx-auto mb-6 sm:mb-9 leading-relaxed px-4" data-id="element-145">
          La guía práctica que ninguna facultad de veterinaria te dio — para que
          en 7 días ya no improvises ninguna conversación difícil con el
          propietario
        </p>

        <div className="bg-white/6 border border-white/12 rounded-2xl p-5 sm:p-8 max-w-2xl mx-auto mb-8 sm:mb-10" data-id="element-146">
          <p className="text-white/90 text-sm sm:text-base leading-relaxed" data-id="element-147">
            Dominá cada conversación difícil con el propietario,{' '}
            <strong className="text-gold-light" data-id="element-148">
              defendé el valor de tu trabajo
            </strong>
            , y salí de cada consulta con el tratamiento cumplido, el dueño
            conforme y{' '}
            <strong className="text-gold-light" data-id="element-149">tu energía intacta.</strong>
          </p>
        </div>

        <motion.a href="#pricing" whileHover={{
        y: -2,
        boxShadow: '0 12px 40px rgba(201,149,42,0.5)'
      }} whileTap={{
        scale: 0.96
      }} className="inline-block bg-gradient-to-br from-gold to-gold-light text-navy font-bold text-sm sm:text-lg px-8 py-3.5 sm:px-11 sm:py-5 rounded-xl shadow-[0_8px_32px_rgba(201,149,42,0.4)] transition-all" data-id="element-150">
          💥 QUIERO MI CONSULTA RESUELTA
        </motion.a>

        <div className="flex flex-wrap justify-center gap-4 sm:gap-7 mt-6 sm:mt-7 text-white/60 text-[11px] sm:text-sm" data-id="element-151">
          <div className="flex items-center gap-1.5 sm:gap-2" data-id="element-152">
            <span className="text-green-light text-sm sm:text-base" data-id="element-153">✓</span>{' '}
            Garantía 7 días
          </div>
          <div className="flex items-center gap-1.5 sm:gap-2" data-id="element-154">
            <span className="text-green-light text-sm sm:text-base" data-id="element-155">✓</span>{' '}
            Pago seguro
          </div>
          <div className="flex items-center gap-1.5 sm:gap-2" data-id="element-156">
            <span className="text-green-light text-sm sm:text-base" data-id="element-157">✓</span>{' '}
            Acceso inmediato
          </div>
        </div>
      </motion.div>
    </section>;
}